import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "../../../environments/environment";

export interface EmailPayload {
  from: string;
  to: string;
  subject: string;
  text: string;
}

@Injectable({ providedIn: 'root' })
export class EmailService {
  constructor(private http: HttpClient) {}

  sendEmail(payload: EmailPayload): Observable<any> {
    return this.http.post( environment.apiUrl + '/api/email/send', payload);
  }
}